<template>
  <el-form-item v-bind="itemBinds" class="master-table" label-width="0">
    <!-- header -->
    <div class="master-table-header">
      <FormHeader>{{ $t('performanceAppraisal.performanceAppraisal.formTitle.evaluationSystem') }}</FormHeader>
    </div>
    <el-tabs v-model="active" @tab-click="handleClick">
      <el-tab-pane
        v-for="(item, index) in value"
        :key="index"
        :name="`${index}`"
      >
        <span slot="label">
          {{ item.tabName }} ({{ item.weight }}%)
        </span>
        <vxe-table
          ref="dataTable"
          :data="activeData.eleList"
          border
          resizable
          show-overflow
          show-header-overflow
          show-footer-overflow
          style="width: 100%"
          max-height="350"
        >
          <vxe-column fixed="left" type="seq" title="#" width="60" align="center" />
          <vxe-column
            v-for="quota of columns"
            :key="quota.prop"
            :title="quota.label"
            :field="quota.prop"
            align="center"
          />
          <template #empty>
            <Empty />
          </template>
        </vxe-table>
      </el-tab-pane>
    </el-tabs>
  </el-form-item>
</template>

<script>
import FormHeader from '@/components/form/form-header/form-header.vue'
import Empty from '../small/empty.vue'
export default {
  name: 'EvaluationSystem',
  components: {
    FormHeader,
    Empty
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    itemBinds: {
      type: Object,
      default: () => ({})
    },
    value: {
      type: Array,
      default: () => ([])
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      columns: [
        { prop: 'quotaNo', label: this.$t('performanceAppraisal.performanceAppraisal.evaluationSystem.quotaNo') },
        { prop: 'quotaName', label: this.$t('performanceAppraisal.performanceAppraisal.evaluationSystem.quotaName') },
        { prop: 'quotaTypeName', label: this.$t('performanceAppraisal.performanceAppraisal.evaluationSystem.quotaTypeName') },
        { prop: 'elementWeight', label: this.$t('performanceAppraisal.performanceAppraisal.evaluationSystem.elementWeight') },
        { prop: 'maxPoints', label: this.$t('performanceAppraisal.performanceAppraisal.evaluationSystem.maxPoints') },
        { prop: 'minPoints', label: this.$t('performanceAppraisal.performanceAppraisal.evaluationSystem.minPoints') },
        { prop: 'examinePersonName', label: this.$t('performanceAppraisal.performanceAppraisal.evaluationSystem.examinePerson') }
      ],
      active: '0',
      evaluationSystem: []
    }
  },
  computed: {
    activeData() {
      return this.value[this.active]
    }
  },
  methods: {
    handleClick(val) {
      console.log(val)
    }
  }
}
</script>

<style scoped>

</style>
